import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// On 401 from app auth (not external API errors), redirect to login.
// Skip redirect on /login itself (infinite-reload guard) and on every other public,
// logged-out-by-design page - AuthContext's fetchMe() runs on every app load regardless of
// route, so a not-logged-in visitor on /invite/:token, /forgot-password, or
// /reset-password/:token always gets a real 401 UNAUTHENTICATED from that check alone. Without
// this list, that 401 hijacked navigation straight back to /login before the intended public
// page (invite acceptance, password reset) could ever render.
const AUTH_ERROR_CODES = ['UNAUTHENTICATED', 'INVALID_TOKEN', 'USER_INACTIVE'];
const PUBLIC_PATH_PREFIXES = ['/login', '/forgot-password', '/reset-password', '/invite'];
apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const onPublicPage = PUBLIC_PATH_PREFIXES.some(p => window.location.pathname.startsWith(p));
    if (
      err.response?.status === 401 &&
      AUTH_ERROR_CODES.includes(err.response?.data?.code) &&
      !onPublicPage
    ) {
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default apiClient;
